<span
  ftrTooltip
  [message]="tooltip?.message ?? ''"
  [forceDisplayState]="tooltip?.forceDisplayState ?? !!tooltip?.message ? undefined : tooltipDisplay.Hide"
  [alignment]="tooltip?.alignment ?? tooltipAlignment.CENTER"
  [position]="tooltip?.position ?? tooltipPosition.ABOVE"
  [showDash]="tooltip?.showDash ?? false"
  [clickToStayOpen]="tooltip?.clickToStayOpen ?? false"
  ><ftr-remote-button
    *ngIf="isActionShown"
    [action]="action"
    [color]="button?.color"
    [displayType]="button?.displayType"
    [size]="button?.size"
    [fullWidth]="button?.fullWidth"
    [direction]="button?.direction"
    [disabled]="button?.disabled"
    [successText]="tableAction.successText"
    [failureText]="tableAction.failureText"
    [useApiFailureText]="tableAction.useApiFailureText"
    [routerParams]="tableAction.routerParams"
    ><ftr-icon
      class="table-cell__icon"
      *ngIf="button?.icon as icon"
      [icon]="icon.name"
      [align]="icon.alignment || 'Sub'"
      [color]="icon.color || 'Grey'"
      [size]="icon.size || 'Regular'"
    ></ftr-icon>
    {{ tableAction.label }}
  </ftr-remote-button>
</span>
